import { render, staticRenderFns } from "./tabZfdetails5.vue?vue&type=template&id=9ef8378c&"
import script from "./tabZfdetails5.vue?vue&type=script&lang=js&"
export * from "./tabZfdetails5.vue?vue&type=script&lang=js&"
import style0 from "./tabZfdetails5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabZfdetails5.vue"
export default component.exports